// extracted by mini-css-extract-plugin
var _1 = "M_hlz";
export { _1 as "base" }
